import { inject, observer } from '../core/store'
import React from 'react'
import {Breadcrumb} from 'antd'
import menu from 'src/core/menu'
import {setTitle} from 'src/helper/platform'
@inject('store')
@observer
export default class extends React.Component {
  bb = []
  getBreadcrumb() {
    let lv1, lv2, title
    const {module, controller, action} = this.props.params

    menu.data.map((v, k) => {
      if (v.key === `/${module}/${controller}/${action}`) {
        lv1 = k
      } else if (v.key === `/${module}/${controller}` && v.sub && v.sub.length > 0) {
        lv1 = k
        v.sub.map((vo, ko) => {
          if (vo.key === `/${module}/${controller}/${action}`) {
            lv2 = ko
          }
        })
      }
    })
    this.bb = []
    if (lv1 >= 0) {
      this.bb.push(menu.data[lv1])
      title = menu.data[lv1].name
    }
    if (lv1 >= 0 && lv2 >= 0) {
      this.bb.push(menu.data[lv1].sub[lv2])
      title += ' - ' + menu.data[lv1].sub[lv2].name
    }
    setTitle(title)
  }
  render() {
    this.getBreadcrumb()
    return (
      <Breadcrumb style={{margin: '16px 0'}}>
        {this.bb.map(v => {
          return (<Breadcrumb.Item key={v.key}>{v.name}</Breadcrumb.Item>)
        })}
      </Breadcrumb>
    )
  }
}



// WEBPACK FOOTER //
// ./layout/Breadcrumb.js